

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// GetchatRoomMessage
// GETCHATROOMMESSAGE
const GETCHATROOMMESSAGE= createAsyncThunk(
  "GetchatRoomMessage/GetchatRoomMessage",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const GetchatRoomMessageSlice = createSlice({
  name: "GetchatRoomMessageSlice",
  initialState: {
    GetchatRoomMessage: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfGetchatRoomMessage: (state) => {
        state.GetchatRoomMessage.loading = false
        state.GetchatRoomMessage.error = false
        state.GetchatRoomMessage.data = []
        state.GetchatRoomMessage.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETCHATROOMMESSAGE.fulfilled, (state, action) => {
      state.GetchatRoomMessage = {
        ...state.GetchatRoomMessage,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETCHATROOMMESSAGE.pending, (state, action) => {
      state.GetchatRoomMessage = {
        ...state.GetchatRoomMessage,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETCHATROOMMESSAGE.rejected, (state, action) => {
      state.GetchatRoomMessage = {
        ...state.GetchatRoomMessage,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const GetchatRoomMessageAction = {
    GETCHATROOMMESSAGE,
};

export { GetchatRoomMessageAction };
export default GetchatRoomMessageSlice.reducer;
export const {setInitialStateOfGetchatRoomMessage} = GetchatRoomMessageSlice.actions